import { render } from "./RegionAlarmTable.vue?vue&type=template&id=1425feae"
import script from "./RegionAlarmTable.vue?vue&type=script&lang=js"
export * from "./RegionAlarmTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__